import {
  Accordion,
  AccordionItem,
  Flex,
  AccordionButton,
  Heading,
  AccordionIcon,
  VStack,
  AccordionPanel,
  Center,
  Spinner,
  Text,
  Box,
  useMediaQuery
} from '@chakra-ui/react'

import Card from 'components/Card'
import EmptyListHandler from 'components/EmptyHandler'

import React from 'react'

type AccordionCardProps = {
  title: string
  subTitle: string
  topRight?: React.ReactNode
  searchBar?: React.ReactNode
  sorts?: React.ReactNode
  filters?: React.ReactNode
  loading?: boolean
  count?: number
  isOpen?: boolean
  dataList: React.ReactNode
  pagination: React.ReactNode
}

const AccordionCard: React.FC<AccordionCardProps> = ({
  title,
  subTitle,
  topRight,
  searchBar,
  sorts,
  filters,
  loading,
  count,
  dataList,
  pagination,
  isOpen
}) => {
  const [isTabletOrMobile] = useMediaQuery('(max-width: 50em)')
  return (
    <Card width="100%" bg="white">
      <Accordion defaultIndex={isOpen ? [0] : []} borderColor="transparent" allowMultiple>
        <AccordionItem>
          <Box p={isTabletOrMobile ? 6 : 8} pb={4}>
            <Flex
              align={isTabletOrMobile ? 'flex-start' : 'center'}
              mb={4}
              direction={isTabletOrMobile ? 'column' : 'row'}
              justify="space-between"
            >
              <AccordionButton
                p={0}
                _hover={{
                  bg: 'transparent'
                }}
                rounded="xl"
                textAlign="left"
              >
                <Box flex={1}>
                  <Heading fontWeight="extrabold" size="lg">
                    {title}
                  </Heading>
                  <Text fontSize="xs" color="gray.500">
                    {subTitle}
                  </Text>
                </Box>
                <AccordionIcon ml={8} />
              </AccordionButton>
              {topRight}
            </Flex>
          </Box>
          <AccordionPanel p={0}>
            <Box px={isTabletOrMobile ? 6 : 8}>
              {searchBar}
              <VStack alignItems="flex-start">
                {sorts}
                {filters}
              </VStack>
            </Box>
            <Box mt={4}>
              {loading ? (
                <Center>
                  <Spinner color="orange.200" />
                </Center>
              ) : (count || 0) === 0 ? (
                <EmptyListHandler minH="50vh" />
              ) : (
                dataList
              )}
            </Box>
            <Box p={isTabletOrMobile ? 6 : 8}>{pagination}</Box>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Card>
  )
}

AccordionCard.defaultProps = {
  isOpen: true
}

export default AccordionCard
